import { render, staticRenderFns } from "./botaoVideo.vue?vue&type=template&id=866dc8ac&scoped=true&"
import script from "./botaoVideo.vue?vue&type=script&lang=js&"
export * from "./botaoVideo.vue?vue&type=script&lang=js&"
import style0 from "./botaoVideo.vue?vue&type=style&index=0&id=866dc8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866dc8ac",
  null
  
)

export default component.exports